import B2BDashboard from "@/pages/b2b_dashboard";
import B2BReport from "@/pages/b2b_report";

const URL_MAPPING = {
  LOGIN: "/auth/login",
  SIGNUP: "/auth/verifymail",
  FORGETPASS: "/forget-pass",
  LOGIN_ROOT: "/",
  TEST: "test",
  ANALYTICS: "/analytics",
  SALESMAN: "/map-view",
  CUSTOMERLIST: "/customer-list",
  TERRITORIES: "/territories",
  DASHBOARD: "/dashboard",
  CUSTOMERLISTDETAILS: "/customer-list-details",
  LANDING: "/home",
  RESETPASS: "/reset-password",
  SDRDASHBOARD:"/sdr-dashboard",
  CALLPLANREPORT:"/call-plan-report",
  GOOGLEAUTH: "/auth/verfiy-qr",
  EMPLOYEETABLE: "/employee-table",
  MASTERLIST: "/master-list",
  AGINGREPORT: "/aging-report",
  ACTIVITYREPORT: "/activity-report",
  DASHBOARDZAMZAM:'/inventory',
  PLANOGRAM: "/planogram",
  NOTIFICATIONS: "/notifications",
  VISITREPORT: "/visit-report",
  DEPOSITREPORT: "/deposit-report",
  SALESREPORT: "/sales-report",
  INVOICEREPORT: "/invoice-report",
  MAPVIEW: "/map-view-updated",
  KAKRREPORT:"/kakr-report",
  DELIVERYDASHBOARD: "/delivery-dashboard",
  DELIVERYREPORT: "/delivery-report",
  DELIVERYIMAGESREPORT: "/delivery-images-report",
  OTPCHECKINREPORT: "/otp-checkin-report",
  INVENTORY:"/inventory",
  CREATEORDER:"/create-order",
  ORDERHISTORY:"/order-history",
  MANAGEADDR:"/manage-addr",
  FINANCE:'/finance',
  STOCKREPORT:"/kakr-stock-report",
  SURVEY:'Survey',
  DYNAMIC:'dynamic',
  REJECTIONREPORT:'/rejection-report',
  SUPERVISORACTIVITYREPORT:'/supervisor-activity-report',
  SUPERVISORDASHBOARD:'/supervisor-dashboard',
  SUPERVISORCOLLECTIONAUDIT:'/supervisor-collection-audit',
  SUPERVISORCUSTOMERCREATION:'/customer-creation-report',
  SUPERVISORLOCATIONCAPTURE:'/location-capture-report',
  SUPERVISORVISITREPORT:'/supervisor-visit-report',
  SUPERVISORPOREPORT:'/po-report',
  B2BREPORT:'/b2b-report',
  SFAFEEDBACKCUSTOMERREPORT:'/sfa-customer-feedback-report',
  TERRITORYMAPVIEW:'/territory-map-view',
  ASSIGNLMDTERRITORY:'/assign-lmd-territory',
  LMDTERRITORY: '/lmd-territory',
  B2BFEEDBACKREPORT:'/b2b-feedback-report',
  SHOPLICENSEREPORT:'/shop-license-report',
  B2BDASHBOARD:'/b2b-dashboard',
  SUPERVISORCOLLECTIONREPORT:'/collection-report',
  SUPERVISORMAP:'/supervisor-map',
  SDRACTIVITYREPORT:'/sdr-activity-report',
  SDRACTIVITYREPORT40:'/sdr-activity-report-40',

    SDRVISITREPORT:'/sdr-visit-report',
    SDRSUMMARYREPORT:'/sdr-summary-report',
  ADMINPANEL: '/employees',
  CUSTOMERS: '/customers',
  EDITEMPLOYEE: (id: string) => `/employees/${id}`,
  EDITCUSTOMER: (id: string) => `/customers/${id}`,
  OFFERS: '/offers',
  ADDNEWOFFERS: '/offers-add-new',
  EDITOFFER: (id: string) => `/edit-offer/${id}`,
  STORAGEMAPPING: '/storage-mapping',
  CREATESTOREAGEMAPPING: '/storage-create',
  VIEWSTORAGEMAPPING: (id: string) => `/view-storage/${id}`,
  MEDIA: '/media',
  ADDNEWMEDIA: '/media-add',
  EDITMEDIA: (id: string) => `/edit-media/${id}`,
  TERRITORY: '/territory',
  ADDNEWTERRITORY: '/territory-add',
  CREATEDUMMYTERRITORY: '/create-territory',
  ADDSALES:'/sales-add',
  EDITTERRITORY: (id: string) => `/territory/${id}`,
  EDITPERM: (id: string) => `/roles-edit-permissions/${id}`,
  EMPLOYEEMONTHLY:'/employee-monthly-target',
  EDITMONTHLY: (id: string) => `/employee-monthly-target-edit/${id}`,
  ADDNEWMONTHLYTARGET:'/employee-add',
  UPLOADMONTHLY:'/employee-upload-monthly',
  CONFIG: '/config',
  EDITCONFIG: (id: string) => `/config-edit/${id}`,
  ADDCONFIG: '/config-add',
  ACTIVATION:'/activation',
  REPORT: '/report',
  ADDREPORT: '/report-add',
  NOTIF:'/notification',
  MASTERSYNC: '/master-sync',
  AUTH: '/roles',
  ROLE_EMPLOYEE: '/employee-roles',
  ROLEPERMISSION:"/role-permissions",
  SALES: '/sales',
  ROADNET:'/roadnet',
  TARGETKPI:'/target-kpi',
  EDITSALES: (id: string) => `/sales-edit/${id}`,
  EDITORDERHISTORY: (id: string) => `/edit-order-history/${id}`,

  ADDRULES:'/roles-add',
  ADDPERMISSIONS: (id: string) =>`/roles-permissions/${id}`,
  ASSIGNROLE: (id: string) =>`/roles-assign/${id}`,
  OTPGENERATION: '/otp-generation',
};

export default URL_MAPPING;
